import { Reducer } from 'redux';

import {
  ThreadActivityLoadFulfilledAction,
  ThreadActivityLoadPendingAction,
  ThreadActivityLoadRejectedAction,
} from '../../domains/threadActivity/actions.types';
import { moveToFulfilled, moveToPending, moveToRejected } from '../types';

import { ThreadActivityEntities } from './types';

export type ThreadActivityLoadAction =
  | ThreadActivityLoadPendingAction
  | ThreadActivityLoadFulfilledAction
  | ThreadActivityLoadRejectedAction;

const initialState: ThreadActivityEntities = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<ThreadActivityEntities, ThreadActivityLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'THREAD_ACTIVITY.LOAD_PENDING':
      return moveToPending(state, [action.payload.threadId]);
    case 'THREAD_ACTIVITY.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.threadId], action.payload.error);
    case 'THREAD_ACTIVITY.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.threadActivity);
    default:
      return state;
  }
};

export default reducer;
